import { yup } from "@swa-ui/object";

let schemas;

export function getMktgLandingHomePageSchemas() {
  if (!schemas) {
    schemas = {
      landingHomePage: mktgLandingHomePageSchema(),
      recentSearches: mktgLandingPageRecentSearchesSchema(),
      upcomingTrips: mktgLandingPageUpcomingTripsSchema(),
      vacationPackages: mktgLandingPageVacationPackagesSchema(),
    };
  }

  return schemas;
}

function mktgLandingHomePageSchema() {
  return yup.object().shape({
    moduledetaildestinationoffers: yup.string().optional(),
    moduledetaildestinationthemes: yup.string().optional(),
    moduleposition: yup.string().optional(),
    widget_position: yup.string().optional(),
  });
}

function mktgLandingPageRecentSearchesSchema() {
  return yup.object().shape({
    atrecentsearches: yup.string().optional(),
    atlastsearch: yup.string().optional(),
  });
}

function mktgLandingPageUpcomingTripsSchema() {
  return yup.object().shape({
    at_boarding_position: yup.string().optional(),
    atnexttripplanechangeovnt: yup.string().optional(),
    banner_upcomingtrips: yup.string().optional(),
    customer_daystotrip: yup.string().optional(),
    customer_minutestodeparture: yup.string().optional(),
    domain_name: yup.string().optional(),
    nexttrip_arrivaltime: yup.string().optional(),
    nexttrip_departuredate: yup.string().optional(),
    nexttrip_departuretime: yup.string().optional(),
    nexttrip_destination: yup.string().optional(),
    nexttrip_origin: yup.string().optional(),
    nexttrip_segmentairports: yup.string().optional(),
    page_description: yup.string().optional(),
    pnr_origin: yup.string().optional(),
    search_token: yup.string().optional(),
    seatsassigned: yup.string().optional(),
    upcomingtrips_button: yup.string().optional(),
    upcomingtrips_count: yup.string().optional(),
    upgradeboard_available: yup.string().optional(),
    upgradeboarding_elr_available: yup.string().optional(),
  });
}

function mktgLandingPageVacationPackagesSchema() {
  return yup.object().shape({
    content_moduledetails: yup.string().optional(),
  });
}
